module.exports = __webpack_public_path__ + "media/components/signup/static/caret-left-d18f17ad4acde24f390317b90fa6abdc.svg";